export function moveBg() {
    const _window = this._window;
    const _document = this._document;
    const movementStrength = 50;
    const height = movementStrength / _window.innerHeight;
    const width = movementStrength / _window.innerWidth;
    const moveBg = _document.querySelector(".move-bg");
    let pageX = 0;
    let pageY = 0;
    let newValueX = 0;
    let newValueY = 0;
    
    _document.addEventListener("mousemove", (e) => {
        pageX = e.pageX - _window.innerWidth / 2;
        pageY = e.pageY - _window.innerHeight / 2;
        newValueX = width * pageX * -1 - 25;
        newValueY = height * pageY * -1 + 50;
        moveBg.style.backgroundPosition = `${newValueX}px ${newValueY}px`;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/move-bg.js